module.exports = __webpack_public_path__ + "e076996d3eedac07d08916dd2e9fb611.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/halldor-and-thordur.jpg
// module id = 441
// module chunks = 0